import { clsx } from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export function Button({ variant = 'primary', size = 'md', className, children, ...props }: ButtonProps) {
  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center font-medium rounded-lg transition-all active:scale-[0.97]',
        size === 'sm' && 'px-3 py-1.5 text-xs gap-1.5',
        size === 'md' && 'px-4 py-2 text-sm gap-2',
        size === 'lg' && 'px-6 py-3 text-base gap-2',
        variant === 'primary' && 'bg-brand-primary text-white hover:bg-brand-primary-light shadow-sm',
        variant === 'secondary' && 'bg-surface-secondary text-text-primary border border-border hover:bg-surface-tertiary',
        variant === 'ghost' && 'text-text-secondary hover:bg-surface-secondary hover:text-text-primary',
        variant === 'danger' && 'bg-brand-danger text-white hover:bg-brand-danger/80',
        props.disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
